export const DO_LOGIN = "doLogin";
export const DO_LOGOUT = "doLogout";
export const DO_VALIDAR_SECAO = "doValidarSessao"

export const SET_PARAMETROS_CONSULT_VOLUMETRIA =
  "guardarParametrosPesquisaVolumetria";
export const SET_RESULT_VOLUMETRIA = "guardarResultadoConsulta";
export const CLEAR_RESULT_VOLUMETRIA = "limparResultadoConsulta";
export const CLEAR_VALUES_PARAMETER_CONSULT = "limparParametrosConsulta";

export const SET_STATUS_PESQUISA = "alterarStatusPesquisa";

// -- temporário
export const SET_PROCESSO_DETALHADOS = "guardarProcessosDetalhados"
// -- temporário
